import type { SoundName, Direction } from '../../types';
import { ColorPicker } from '../ColorPicker';
import { DirectionPicker } from '../DirectionPicker';
import { SoundPicker } from '../SoundPicker';

/**
 * SimpleLayout - Simplified control layout for basic users
 *
 * Features:
 * - 4 colors (Blue, Teal, Purple, Pink)
 * - 3 directions (horizontal, vertical, diagonal)
 * - 2 sounds (beep, tap)
 * - Speed control
 * - Vertical stack layout
 */

interface SimpleLayoutProps {
  color: string;
  direction: Direction;
  sound: SoundName;
  isPro: boolean;
  onColorChange: (color: string) => void;
  onDirectionChange: (direction: Direction) => void;
  onSoundChange: (sound: SoundName) => void;
}

export function SimpleLayout({
  color,
  direction,
  sound,
  isPro,
  onColorChange,
  onDirectionChange,
  onSoundChange,
}: SimpleLayoutProps): JSX.Element {
  return (
    <div className="space-y-6">
      <ColorPicker
        value={color}
        onChange={onColorChange}
        disabled={false}
        isPro={isPro}
        mode="simple"
      />

      <DirectionPicker
        value={direction}
        onChange={onDirectionChange}
        disabled={false}
        isPro={isPro}
        mode="simple"
      />

      <SoundPicker
        value={sound}
        onChange={onSoundChange}
        disabled={false}
        isPro={isPro}
        mode="simple"
      />
    </div>
  );
}
